import React, { useState, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

//ANT IMPORTS
import { theme } from "antd";
import { ConfigProvider, Layout } from "antd";
import en_GB from "antd/locale/en_GB";
// import frFR from 'antd/es/locale/fr_FR';

//PROJECT IMPORTS
import RightSidebar from "../RightSidebar";
import Sidebar from "../Sidebar";
import LayoutHeader from "./LayoutHeader";
// import RightSidebar from "./RightSidebar";

const { Content } = Layout;

const MainLayout = (props) => {
  const [switchLabel, setSwitchLabel] = useState("Dark Mode");
  const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
  const [menuBG, setMenuBG] = useState("#000c18");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function onSwitchClick() {
    if (switchLabel === "Dark Mode") {
      setSwitchLabel("Light Mode");
      setMenuBG("#fff");
      setSearchColorBgContainer("#f7f8fa");
      setSwitchLabelColor("#8c8f9f");
      setMenuTheme("light");
    } else {
      setSwitchLabelColor("#aeaeae");
      setSwitchLabel("Dark Mode");
      setMenuBG("#000c18");
      setSearchColorBgContainer("#3B2639");
      setMenuTheme("dark");
    }
  }

  const {
    children,
    isEnableRightSidebar,
    defaultSelectedKeys,

    // right sidebar params
    onSearch,
    onView,
    onAdd,
    onSave,
    onEdit,
    onDelete,
    onApprove,
    onReject,
    onDisburse,
    onRun,
    pageItems,
  } = props;

  //DECLARED VARIABLES
  const [collapsed, setCollapsed] = useState(false);
  const [searchColorBgContainer, setSearchColorBgContainer] = useState("#3B2639");
  const [menuTheme, setMenuTheme] = useState("light");
  const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
  const [logoDimensions, setLogoDimensions] = useState(50);
  const [menuSearchBarState, setMenuSearchBarState] = useState(false);
  const [menuSearchIconState, setMenuSearchIconState] = useState(true);
  const [switchLabelState, setSwitchLabelState] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  useEffect(() => {
    if (collapsed === true) {
      setLeftLayoutMargin(71);
      setLogoDimensions(50);
      setMenuSearchBarState(true);
      setMenuSearchIconState(false);
      setSwitchLabelState(true);
    } else {
      setLeftLayoutMargin(190);
      setLogoDimensions(50);
      setMenuSearchBarState(false);
      setMenuSearchIconState(true);
      setSwitchLabelState(false);
    }
  });

  // // BEGIN IDLE LOGIC

  // const handleOnIdle = (event) => {
  //   console.log("last active", getLastActiveTime());

  //   navigate("/sign-in");
  // };

  // const handleOnActive = (event) => {
  //   console.log("user is active", event);
  //   console.log("time remaining", getRemainingTime());
  // };

  // const handleOnAction = (event) => {
  //   console.log("user did something", event);
  // };

  // const { getRemainingTime, getLastActiveTime } = useIdleTimer({
  //   // timeout: 1000 * 60 * 5,
  //   timeout: 10_0,
  //   onIdle: handleOnIdle,
  //   onActive: handleOnActive,
  //   onAction: handleOnAction,
  //   debounce: 250,
  // });

  //END IDLE LOGIC

  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            siderBg: menuBG,
          },
          Menu: {
            darkItemBg: menuBG,
            darkSubMenuItemBg: "#241223",
          },
        },
      }}
      locale={en_GB}
    >
      <Layout style={{ height: "auto" }}>
        <Sidebar
          collapsed={collapsed}
          colorBgContainer={searchColorBgContainer}
          theme={menuTheme}
          switchLabel={switchLabel}
          onSwitchClick={onSwitchClick}
          switchLabelColor={switchLabelColor}
          logoDimensions={logoDimensions}
          menuSearchBarState={menuSearchBarState}
          menuSearchIconState={menuSearchIconState}
          switchLabelState={switchLabelState}
          setCollapsed={setCollapsed}
        />
        <Layout
          style={{
            marginLeft: leftLayoutMargin,
            backgroundColor: "#F7F9FC",
          }}
        >
          <LayoutHeader
            colorBgContainer={colorBgContainer}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            pageItems={pageItems}
          />
          <Content
            style={{
              margin: "0px 60px 25px 25px",
              minHeight: "calc(100vh - 112px)",
              height: "100%",
              borderRadius: "20px",
              padding: 0,
            }}
          >
            {children}

            {/* ENABLE OR DISABLE RIGTH SIDEBAR */}
            {isEnableRightSidebar && (
              <RightSidebar
                onSearch={onSearch}
                onAdd={onAdd}
                onView={onView}
                onSave={onSave}
                onEdit={onEdit}
                onDelete={onDelete}
                onApprove={onApprove}
                onReject={onReject}
                onDisburse={onDisburse}
                onRun={onRun}
              />
            )}
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default MainLayout;
